import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import logo from '../../assets/images/monitGPS.png';

function Watermark() {
  const map = useMap();

  useEffect(() => {
    if (map._watermarkAdded) return;

    L.Control.Watermark = L.Control.extend({
      onAdd: function () {
        const img = L.DomUtil.create('img');
        img.src = logo;
        img.style.width = '60px';
        img.style.opacity = '0.8';
        img.style.marginBottom = '35px';
        return img;
      },
    });

    L.control.watermark = function (opts) {
      return new L.Control.Watermark(opts);
    };

    L.control.watermark({ position: 'bottomright' }).addTo(map);
    map._watermarkAdded = true;
  }, [map]);

  return null;
}

export default Watermark;
